<template>
  <div id="PlayersRecall">
    <mt-header :title="this.$store.getters.WordsConfig.RecallUser.title">
      <router-link to slot="left">
        <mt-button icon="back"
                   @click.native="$router.back(-1)">{{this.$store.getters.WordsConfig.User.back}}</mt-button>
      </router-link>
    </mt-header>
    <el-row :gutter="3">
      <el-col :span="24">
        <el-col :span="9">
          <span class="titels">{{this.$store.getters.WordsConfig.RecallUser.lastlogintime}}：</span>
        </el-col>
        <el-col :span="4">
          <el-input v-model="formmodel.MinDays" maxlength="3" :placeholder="$store.getters.WordsConfig.RecallUser.minday" oninput="value=value.replace(/[^\d]/g,'')"></el-input>
        </el-col>
        <el-col :span="1">
          <span style="vertical-align:middle;line-height:40px;font-size:14px;text-align:center;width:100%;display:block">
            -
          </span>
        </el-col>
        <el-col :span="4">
          <el-input v-model="formmodel.MaxDays" maxlength="3" :placeholder="$store.getters.WordsConfig.RecallUser.maxday" oninput="value=value.replace(/[^\d]/g,'')"></el-input>
        </el-col>
        <el-col :span="4">
          <el-checkbox v-model="formmodel.DaysType" @change="handlecheckboxChange" style="padding-left: 5px;line-height: 40px;">{{this.$store.getters.WordsConfig.RecallUser.more}}</el-checkbox>
        </el-col>
      </el-col>
    </el-row>

    <el-row :gutter="3" style="padding:5px 0 0 0">
      <el-col :span="14" style="padding:0 5px">
        <el-col :span="16">
          <span class="titels">{{this.$store.getters.WordsConfig.RecallUser.usertype}}：</span>
        </el-col>
        <el-col :span="8">
          <el-select v-model="formmodel.CheckType" clearable @change="handleChange" :placeholder="$store.getters.WordsConfig.RecallUser.checked">
            <el-option v-for="item in selectoptions"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
        </el-col>
      </el-col>
      <el-col :span="10" v-show="vshow">

        <el-col :span="14">
          <span class="titels">{{this.$store.getters.WordsConfig.RecallUser.recharge}}：</span>
        </el-col>
        <el-col :span="9">
          <el-input v-model="formmodel.RechargeScore" :placeholder="$store.getters.WordsConfig.RecallUser.recharge" oninput="value=value.replace(/[^\d]/g,'')"></el-input>
        </el-col>

      </el-col>

      <el-col :span="23" style="height:40px;line-height:40px;text-align:right;padding-top:5px;">
        <el-button size="mini" type="info" plain>{{this.$store.getters.WordsConfig.RecallUser.total}}：{{totalcount}}</el-button>
        <el-button size="mini" type="primary" icon="el-icon-search" @click="GetResult()">{{this.$store.getters.WordsConfig.WorkRecord.query}}</el-button>
        <el-button size="mini" type="primary" icon="el-icon-download" @click="getExcel()">{{this.$store.getters.WordsConfig.RecallUser.download}}</el-button>
      </el-col>

    </el-row>

    <el-container style="inset: 190px 0px 26px 0px; position: absolute">
      <el-main>

        <el-table :data="this.data" height="100%" :empty-text="this.$store.getters.WordsConfig.TBEmptyText">
          <el-table-column fixed
                           prop="gameID"
                           sortable
                           :label="this.$store.getters.WordsConfig.RecallUser.gameId"
                           header-align="center"
                           align="center"
                           width="120"></el-table-column>
          <el-table-column prop="accounts"
                           sortable
                           :label="this.$store.getters.WordsConfig.RecallUser.gameAccount"
                           width="120"
                           header-align="center"
                           align="center"></el-table-column>
          <el-table-column prop="registerDate"
                           sortable
                           :label="this.$store.getters.WordsConfig.RecallUser.registerdate"
                           width="180"
                           header-align="center"
                           align="center"></el-table-column>
          <el-table-column prop="lastLogonDate"
                           sortable
                           :label="this.$store.getters.WordsConfig.RecallUser.lastlogondate"
                           width="180"
                           header-align="center"
                           align="center"></el-table-column>
          <el-table-column prop="totalRecharge"
                           sortable
                           :label="this.$store.getters.WordsConfig.RecallUser.totalrecharge"
                           width="150"
                           header-align="center"
                           align="center"></el-table-column>
          <el-table-column prop="totalExchange"
                           sortable
                           :label="this.$store.getters.WordsConfig.RecallUser.totalexchange"
                           width="150"
                           header-align="center"
                           align="center"></el-table-column>
          <el-table-column prop="betScore"
                           sortable
                           :label="this.$store.getters.WordsConfig.RecallUser.betscore"
                           width="150"
                           header-align="center"
                           align="center"></el-table-column>
          <el-table-column prop="firstGame"
                           :label="this.$store.getters.WordsConfig.RecallUser.firstgame"
                           width="150"
                           header-align="center"
                           align="center"></el-table-column>
          <el-table-column prop="secondGame"
                           :label="this.$store.getters.WordsConfig.RecallUser.secondgame"
                           width="150"
                           header-align="center"
                           align="center"></el-table-column>
          <el-table-column prop="thirdGame"
                           :label="this.$store.getters.WordsConfig.RecallUser.thirdgame"
                           width="150"
                           header-align="center"
                           align="center"></el-table-column>

        </el-table>

        <el-pagination small
                       class="pagination"
                       background
                       :total="totalcount"
                       :page-size="formmodel.PageSize"
                       :current-page.sync="formmodel.CurrentPage"
                       layout="prev, pager, next"
                       @current-change="getNextPage"></el-pagination>

      </el-main>
    </el-container>


  </div>
</template>

<script>
  import { G_RecallUsersPage } from "../../api/api";
  export default {
    data() {
      return {
        totalcount: 0,
        vshow: false,
        checked: "1",
        selecttype: "1",
        selectoptions: [
          { value: 1, label: this.$store.getters.WordsConfig.RecallUser.allusers },
          { value: 2, label: this.$store.getters.WordsConfig.RecallUser.rechargeusers },
          { value: 3, label: this.$store.getters.WordsConfig.RecallUser.mrechargeusers }],
        formmodel:
        {
          CurrentPage: 1,
          PageSize: 20,
          MinDays: 0,
          MaxDays: 0,
          DaysType: 0,
          CheckType: 1,
          RechargeScore: 0,
          downexcel: 0,
          Lang: this.$store.state.Lang
        },
        data: [],
        exceldata: []
      };
    },
    created() {
      this.GetResult();
    },
    methods: {
      showDate(a) {
        console.log(this.$moment(a).format("YYYY-MM-DD"));
      },

      GetResult() {
        this.formmodel.downexcel = 0;
        if (!this.formmodel.DaysType) {
          if (parseInt(this.formmodel.MinDays) > parseInt(this.formmodel.MaxDays)) {
            this.MessageBox({
              title: this.$store.getters.WordsConfig.Registe.msgBox_title,
              message: this.$store.getters.WordsConfig.RecallUser.msgBox_error,
              confirmButtonText: this.$store.getters.WordsConfig.FindPassWord.button
            });
          }
        }

        G_RecallUsersPage(this.formmodel)
          .then(res => {
            this.data = res.data.data;
            this.totalcount = res.data.dataCount;
          })

      },
      getNextPage() {
        this.GetResult();
      },
      handlecheckboxChange() {
        this.formmodel.CurrentPage = 1;
        this.GetResult();
      },
      handleChange() {
        if (this.formmodel.CheckType === 3) {
          this.vshow = true;
        }
        else {
          this.formmodel.RechargeScore = 0;
          this.vshow = false;
        }
      },
      getExcel() {
        this.formmodel.downexcel = 1;
        G_RecallUsersPage(this.formmodel).then(res => {
          console.log(res.data)
          if (res.data.dataCount > 0) {
            require.ensure([], () => {
              console.log('导出表格')
              const { export_json_to_excel } = require('../../assets/js/Export2Excel.js')
              const tHeader = [
                this.$store.getters.WordsConfig.RecallUser.gameId,
                this.$store.getters.WordsConfig.RecallUser.gameAccount,
                this.$store.getters.WordsConfig.RecallUser.registerdate,
                this.$store.getters.WordsConfig.RecallUser.lastlogondate,
                this.$store.getters.WordsConfig.RecallUser.totalrecharge,
                this.$store.getters.WordsConfig.RecallUser.totalexchange,
                this.$store.getters.WordsConfig.RecallUser.betscore,
                this.$store.getters.WordsConfig.RecallUser.firstgame,
                this.$store.getters.WordsConfig.RecallUser.secondgame,
                this.$store.getters.WordsConfig.RecallUser.thirdgame
              ]
              const filterVal = ['gameID', 'accounts', 'registerDate', 'lastLogonDate', 'totalRecharge', 'totalExchange', 'betScore', 'firstGame', 'secondGame', 'thirdGame']
              const list = res.data.data
              const data = this.formatJson(filterVal, list)
              export_json_to_excel(tHeader, data, this.$store.getters.WordsConfig.RecallUser.title)
            })
          }
          else {
            console.log('提示')
            this.MessageBox({
              title: this.$store.getters.WordsConfig.Registe.msgBox_title,
              message: this.$store.getters.WordsConfig.RecallUser.msgBox_excelerror,
              confirmButtonText: this.$store.getters.WordsConfig.FindPassWord.button
            });
          }
        })
      },
      formatJson(filterVal, jsonData) {
        return jsonData.map(v => filterVal.map(j => v[j]));
      }
    }
  };
</script>

<style lang="scss" scoped>
  #PlayersRecall {
    height: 100%;
    overflow: hidden;
  }

  .pagination {
    position: absolute;
    bottom: -26px;
    width: 100%;
    background: white;
    text-align: center;
  }

  .wrBtn {
    width: 25%;
    font-size: small;
    padding: 2px 0;
    margin: 4px;
  }

  .el-row {
    padding: 10px 0;
  }

  .titels {
    line-height: 40px;
    font-size: 14px;
    text-align: right;
    width: 100%;
    display: block;
  }
</style>



// WEBPACK FOOTER //
// src/components/Cells/PlayersRecall.vue